import React from "react";

export default function IconRequestReceived() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8594 18.8281H11.1717C16.3665 11.9025 17.6172 10.7984 17.6172 7.61719C17.6172 3.41719 14.2 0 10 0C5.8 0 2.38281 3.41719 2.38281 7.61719C2.38281 10.7932 3.62273 11.8876 8.8284 18.8281H4.14062C3.81676 18.8281 3.55469 19.0902 3.55469 19.4141C3.55469 19.7379 3.81676 20 4.14062 20H15.8594C16.1832 20 16.4453 19.7379 16.4453 19.4141C16.4453 19.0902 16.1832 18.8281 15.8594 18.8281ZM4.72656 7.61719C4.72656 4.70926 7.09207 2.34375 10 2.34375C12.9079 2.34375 15.2734 4.70926 15.2734 7.61719C15.2734 10.5705 12.7743 12.8906 10 12.8906C7.21766 12.8906 4.72656 10.5627 4.72656 7.61719Z"
        fill="#"
      />
      <path
        d="M10 4.6875C8.70738 4.6875 7.65625 5.73863 7.65625 7.03125C7.65625 8.32387 8.70738 9.375 10 9.375C11.2926 9.375 12.3438 8.32387 12.3438 7.03125C12.3438 5.73863 11.2926 4.6875 10 4.6875Z"
        fill="#"
      />
      <path
        d="M12.6012 9.375C11.9573 10.089 11.035 10.5469 9.99996 10.5469C8.96496 10.5469 8.04266 10.089 7.39871 9.375C7.17992 9.61762 7.0052 9.89656 6.8584 10.1914C7.61781 11.1102 8.74711 11.7188 9.99996 11.7188C11.2528 11.7188 12.3821 11.1102 13.1415 10.1914C12.9948 9.89652 12.82 9.61762 12.6012 9.375Z"
        fill="#"
      />
    </svg>
  );
}
